module.exports = __webpack_public_path__ + "static/media/developerActivity.f5d7b7c2.svg";